import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={100}
    height={100}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M49.035 0c-4.093.02-8.001.366-11.44.969-10.13 1.774-11.97 5.487-11.97 12.334v9.043h23.94v3.014H16.64c-6.958 0-13.05 4.145-14.956 12.03-2.198 9.038-2.295 14.678 0 24.115 1.702 7.025 5.766 12.03 12.723 12.03h8.232v-10.84c0-7.832 6.836-14.74 14.955-14.74h23.912c6.656 0 11.97-5.433 11.97-12.058V13.303c0-6.43-5.474-11.261-11.97-12.334C57.394.29 53.127-.018 49.035 0ZM36.088 7.275c2.473 0 4.492 2.034 4.492 4.535 0 2.493-2.019 4.508-4.492 4.508a4.498 4.498 0 0 1-4.492-4.508c0-2.5 2.01-4.535 4.492-4.535Z"
      />
      <path
        fill="url(#c)"
        d="M76.462 25.36v10.537c0 8.169-6.987 15.044-14.955 15.044H37.595c-6.55 0-11.97 5.556-11.97 12.058v22.594c0 6.43 5.642 10.212 11.97 12.057 7.578 2.209 14.845 2.608 23.912 0 6.027-1.73 11.97-5.21 11.97-12.057v-9.044H49.565v-3.014h35.882c6.957 0 9.55-4.81 11.97-12.03 2.499-7.432 2.392-14.58 0-24.115-1.72-6.865-5.004-12.03-11.97-12.03h-8.985ZM63.013 82.578a4.498 4.498 0 0 1 4.493 4.508c0 2.501-2.01 4.535-4.493 4.535-2.472 0-4.492-2.034-4.492-4.535 0-2.492 2.02-4.508 4.492-4.508Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={0}
        x2={54.789}
        y1={0}
        y2={47.105}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A9FD4" />
        <stop offset={1} stopColor="#306998" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={62.438}
        x2={42.866}
        y1={86.326}
        y2={58.655}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD43B" />
        <stop offset={1} stopColor="#FFE873" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h100v100H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
